import { CLEAR_ALL_DATA, RESET_APP_ERROR, SAVE_APP_DATA, SET_CHILDREN_YEARS_LIST, CHANGE_YEARS_LIST_VALUES, SET_YEARS_STRING } from '../../helper/constants';

const initialState = {
  validForYear: '',
  firstName: '',
  middleName: '',
  surName: '',
  email: '',
  isOwnPartBusiness: '',
  relationshipStatus: '',

  firstNameSecond: '',
  middleNameSecond: '',
  surNameSecond: '',
  emailSecond: '',
  isOwnPartBusinessSecond: '',

  isParentLivedInSameHousehold: '',
  isAlwaysLivedinCountryResidence: '',
  countryResidenceFamily: '',
  familySituationDescribeInfo: '',

  childrenYearsList: [],
  childrenYearsCountry: ""
}

export default (state = initialState, {type, payload}) => {
  switch(type) {
    case SAVE_APP_DATA: {
      return {
        ...state,
        ...payload,
      }
    }
    case CLEAR_ALL_DATA: {
      return {
        ...initialState,
        ...payload
      }
    }
    case RESET_APP_ERROR: {
      return {
        ...state,
        error: '',
        errorScreenMessage: '',
        errorScreenCounter: 0
      }
    }
    case SET_CHILDREN_YEARS_LIST: {
      return {
        ...state,
        childrenYearsList: payload
      }
    }
    case SET_YEARS_STRING: {
      return {
        ...state,
        childrenYearsCountry: payload
      }
    }
    case CHANGE_YEARS_LIST_VALUES: {
      const { index, countryData, year } = payload

      state.childrenYearsList[index] = {
        year: year,
        value: countryData[0].value
      }

      return {
        ...state,
        childrenYearsList: [
          ...state.childrenYearsList,
        ]
      }
    }
    default:
      return state;
  }
}

export const getInitialValue = (fieldName, fallbackValue) => {
  return initialState.hasOwnProperty(fieldName) ? initialState[fieldName] : fallbackValue;
}

export const getInitialField = (field) => {
  const fieldName = Object.keys(field)[0];
  return {
    [fieldName]: getInitialValue(fieldName)
  }
}